import React from "react";

const Icon = (props) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 54 27" {...props}>
    <path
      fill="#fff"
      d="M21.435 27l-4.344-8.452c1.903-.931 4.308-3.116 4.308-7.235 0-4.477-3.016-8.202-8.617-8.202H0V27h7.253v-7.521h2.62L13.178 27h8.258zM11.67 13.175H7.253v-3.76h4.416c1.22 0 2.37.573 2.37 1.862 0 1.325-1.15 1.898-2.37 1.898zM43.085 27v-8.918h10.664V11.78H43.085V9.415H54V3.11H35.832V27h7.253zM26.45 9.254c2.329 0 3.904-1.088 3.904-2.686 0-1.236-1.131-1.988-2.127-2.096 1.144-.188 1.979-1.034 1.979-1.987C30.206 1.007 28.94 0 26.463 0c-1.75 0-2.976.604-3.77 1.477l1.279 1.693a3.507 3.507 0 012.194-.78c.781 0 1.333.162 1.333.578 0 .282-.377.443-1.238.443-.323 0-1.131 0-1.306-.013v2.404c.134-.013.915-.027 1.306-.027 1.198 0 1.387.175 1.387.484 0 .322-.418.604-1.306.604-.687 0-1.737-.255-2.438-.86l-1.332 1.854c.754.806 2.1 1.397 3.877 1.397z"
    />
  </svg>
);

export default Icon;
